<template>
  <div id="occupantType">
    <multiselect
      :class="{ 'border-bottom-blue': isOccupantTypeSet && !isOpened }"
      ref="multiselect"
      v-model="occupantTypeValue"
      :options="occupantTypeOptions"
      placeholder="locataire"
      :searchable="false"
      :multiple="false"
      :allow-empty="false"
      :close-on-select="true"
      :show-labels="false"
      @close="isOpened = false"
      @open="isOpened = true"
    >
      <span
        class="caret"
        slot-scope="{ toggle }"
        :class="{ 'border-blue': isOccupantTypeSet }"
        @mousedown.prevent.stop="toggle"
        slot="caret"
      ></span>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      isOpened: false,
      occupantTypeOptions: ["locataire", "propriétaire"],
    };
  },
  computed: {
    occupantTypeValue: {
      get() {
        return this.$store.state.optionalFields.occupantType;
      },
      set(value) {
        this.$store.commit("SET_OCCUPANT_TYPE", value);
      },
    },
    ...mapGetters(["isOccupantTypeSet"]),
  },
  methods: {
    focus() {
      this.$refs.multiselect.$el.focus();
    },
  },
  mounted() {
    this.focus();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/multiselect.scss";
.multiselect {
  width: 10rem;
  margin-left: 1rem;
}
</style>
